(() => {
  "use strict";

  let sortingScheduled = false;

  function getNumericSize(element) {
    const text = element.textContent
      .trim()
      .replace("½", ".5");

    const size = Number.parseFloat(text);

    return Number.isFinite(size) ? size : 9999;
  }

  function sortSection(section) {
    const buttons = Array.from(
      section.querySelectorAll(":scope > [data-js-option-value]")
    );

    if (buttons.length < 2) {
      return;
    }

    const sortedButtons = [...buttons].sort(
      (a, b) => getNumericSize(a) - getNumericSize(b)
    );

    const alreadySorted = buttons.every(
      (button, index) => button === sortedButtons[index]
    );

    if (alreadySorted) {
      return;
    }

    sortedButtons.forEach((button) => {
      button.style.removeProperty("order");
      section.appendChild(button);
    });
  }

  function sortAllProductSizes() {
    document
      .querySelectorAll(
        '.product-options__section[data-property="ussize"]'
      )
      .forEach(sortSection);
  }

  function scheduleSort() {
    if (sortingScheduled) {
      return;
    }

    sortingScheduled = true;

    window.requestAnimationFrame(() => {
      sortingScheduled = false;
      sortAllProductSizes();
    });
  }

  document.addEventListener("DOMContentLoaded", scheduleSort);
  window.addEventListener("load", scheduleSort);
  document.addEventListener("shopify:section:load", scheduleSort);

  const observer = new MutationObserver((mutations) => {
    const productOptionsChanged = mutations.some((mutation) => {
      return Array.from(mutation.addedNodes).some((node) => {
        if (!(node instanceof Element)) {
          return false;
        }

        return (
          node.matches?.(
            '.product-options__section[data-property="ussize"], [data-js-option-value]'
          ) ||
          node.querySelector?.(
            '.product-options__section[data-property="ussize"]'
          )
        );
      });
    });

    if (productOptionsChanged) {
      scheduleSort();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setTimeout(scheduleSort, 500);
  setTimeout(scheduleSort, 1500);
  setTimeout(scheduleSort, 3000);
})();